export default function getRefineByCount(pageParameters) {
  const { filters, customFilters, priceFilters, cluster, hiddenOOS } = pageParameters;

  let result = 0;
  if (filters) result += filters.length;
  if (customFilters) result += customFilters.length;
  if (priceFilters) result += priceFilters.length;
  if (cluster) ++result;
  if (hiddenOOS) ++result;
  return result;
}
